import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { ParcService } from '../../parc/services/parc.service';

import { GroupementParc } from '../../groupement-parc/entities/groupement-parc.entity';
import { OuvrageTLR } from '../entities/ouvrage-tlr.entity';
import { ParcTLR } from '../../parc/entities/parc-tlr.entity';


@Component({
	selector: 'ouvrage-by-groupement-multi-selector',
	templateUrl: 'ouvrage-by-groupement-multi-selector.html',
})
export class OuvrageByGroupementMultiSelectorComponent {
	
	parcs: ParcTLR[] = [];
	ouvrages: OuvrageTLR[] = [];

	getParcLabel = (parc: ParcTLR) => '... dans ' + parc.description + ' (' + parc.code + ')';
	checkCategory = (ouvrage: OuvrageTLR, parc: ParcTLR) => {
		if (parc) {
			return ouvrage.parcId === parc.id;
		}
		return false;
	}
	isOuvragePreselected = (ouvrage: OuvrageTLR) => this._selectedOuvrageIds.includes(ouvrage.id);
	
	reinitSubject = new Subject<void>();

	constructor( //
		@Inject(ParcService) private parcService: ParcService //
	) { }

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	@Input() maxNumberOfSelections: number | null = null;
	
	@Input() label: string = 'Ouvrage(s)';
	
	// Classes pour l'affichege
	public _labelClass: string = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}

	public getOuvrageLabel = (ouvrage: OuvrageTLR | null | undefined) => {
		if (ouvrage) {
			return ouvrage.nom + (ouvrage.description ? ' (' + ouvrage.description + ')' : '');
		}
		return '';
	};
	@Input() set ouvrageLabelGetter(labelGetterFunction: (ouvrage: OuvrageTLR) => string) {
		this.getOuvrageLabel = (ouvrage: OuvrageTLR | null | undefined) => {
	  		if (ouvrage) {
 				return labelGetterFunction(ouvrage);
			}
			return '';
		};
	} 

	private _selectedParcIds!: number[] | undefined;
	@Input() set selectedParcIds(parcIds: number[] | undefined) {
		if (parcIds) {
			this.parcs = [];
			this._selectedParcIds = parcIds;
			parcIds.forEach( parcId => {
				this.parcService.getParcTLRById(parcId).subscribe(
					(parc: ParcTLR) => {
						this.parcs.push(parc);
					}
				);
			} );
			this.updateListOuvrages();
		}
	}
	
	private _groupement!: GroupementParc;
	@Input() set groupement(gp: GroupementParc) {
		this._groupement = gp;
		this.updateListOuvrages();
	}
	
	private updateListOuvrages(): void {
		let authorizedParcids: number[] = this._selectedParcIds ? this._selectedParcIds : [];
		if (this._groupement && this._groupement.ouvrages) {
			this.ouvrages = this._groupement.ouvrages
				.filter( o => authorizedParcids.indexOf(o.parcId) > -1 )
				.sort( (o1, o2) => o1.nom.localeCompare(o2.nom) );
		}
	}
	
	private _selectedOuvrageIds: number[] = [];
	@Input() set selectedOuvrageIds(ids: number[] | undefined) {
		if (ids != undefined) {
			this._selectedOuvrageIds = ids;
			this.reinitSubject.next();
		}
	}
	get selectedOuvrageIds(): number[] | undefined {
		return this._selectedOuvrageIds;
	}
	
	@Output() selectedOuvrageIdsChange = new EventEmitter<number[]>();
	
	@Output() selectedOuvragesChange = new EventEmitter<OuvrageTLR[]>();
	
	onSelectedOuvragesChange(ouvrages: OuvrageTLR[]) {
		let ids = ouvrages.map((ouvrage: OuvrageTLR) => ouvrage.id);
		this._selectedOuvrageIds = ids;
		this.selectedOuvrageIdsChange.emit(ids);
		this.selectedOuvragesChange.emit(ouvrages);
	}
}